import React from "react"
import PropTypes from "prop-types"

export default function SwiftLogoIcon({ color, height, width, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "96"}
      height={height || "96"}
      fill="none"
      viewBox="0 0 96 96"
      className={className}
    >
      <rect
        width={height * 0.9792 || "94"}
        height={width * 0.9792 || "94"}
        x="1"
        y="1"
        stroke={color || "#000"}
        strokeWidth="2"
        rx="21"
      ></rect>
      <path
        fill={color || "#000"}
        d="M66.33 61l-.833.554.963 1.449.768-1.562zm-4.569-18.14l-.956-.293-.177.579.431.426zM41.661 1l.475-.88a1 1 0 00-1.273 1.483zm5.938 31.628l-.507.862 1.036.61.411-1.13zM15.621 6.116l.764-.644a1 1 0 00-1.628 1.148zm18.273 23.721l-.47.882a1 1 0 001.148-1.617zM7.399 9.372l.67-.741a1 1 0 00-1.491 1.312zm31.066 34.419l.657.753.969-.845-1.058-.73zM1 39.14l.65-.76A1 1 0 00.125 39.62zm27.411 20.465l-.24.97.03.008.032.006zm38.816 1.836c1.2-2.44 3.365-11.268-4.763-19.292l-1.405 1.423c7.35 7.256 5.307 15.087 4.373 16.987zm-4.51-18.287c2.38-7.75.934-16.507-2.915-24.284C55.953 11.089 49.647 4.182 42.136.12l-.951 1.76c7.109 3.844 13.138 10.426 16.826 17.877 3.69 7.456 4.985 15.676 2.795 22.81zM40.863 1.603c4.476 5.924 10.198 18.585 5.798 30.683l1.88.684C53.275 19.952 47.12 6.567 42.458.397zm7.245 30.164c-4.274-2.52-10.578-7.156-16.65-12.155-6.075-5.002-11.843-10.304-15.072-14.14l-1.53 1.289c3.35 3.979 9.232 9.374 15.331 14.395 6.103 5.025 12.5 9.737 16.906 12.334zM14.758 6.62c2.908 4.988 10.673 16.78 18.46 23.953l1.354-1.471c-7.564-6.968-15.21-18.555-18.088-23.49zm19.607 22.335C24.905 23.91 12.212 12.382 8.068 8.632l-1.342 1.483c4.08 3.692 16.971 15.419 26.698 20.606zM6.577 9.945c5.924 8.506 18.354 25.714 31.318 34.67l1.137-1.646C26.412 34.251 14.172 17.35 8.218 8.802zm31.23 33.094c-1.42 1.238-3.658 2.204-6.487 2.775-2.811.567-6.126.725-9.614.413-6.99-.627-14.542-3.13-20.055-7.846l-1.3 1.52c5.909 5.053 13.89 7.665 21.177 8.318 3.65.327 7.16.165 10.188-.445 3.01-.607 5.625-1.675 7.405-3.228zM.124 39.622c2.986 5.44 12.716 17.148 28.047 20.954l.482-1.94C14.015 55 4.68 43.762 1.88 38.658zm28.11 20.968c10.43 1.888 15.778.726 19.71-.998a40.4 40.4 0 002.639-1.3c.817-.43 1.563-.827 2.333-1.176 1.51-.683 3.082-1.16 5.191-1.16v-2c-2.459 0-4.313.568-6.016 1.338-.836.379-1.642.809-2.44 1.23a38.5 38.5 0 01-2.51 1.236c-3.492 1.532-8.423 2.696-18.551.862zm29.873-4.635c1.467 0 2.96.823 4.323 2.024 1.344 1.183 2.43 2.618 3.068 3.576l1.665-1.107c-.692-1.041-1.89-2.63-3.411-3.97-1.502-1.322-3.457-2.523-5.645-2.523z"
        transform="translate(12.42 15.714)"
      ></path>
    </svg>
  )
}

SwiftLogoIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
